/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Replace_All_LabelInputs */



/**
* | output |
* | --- |
* | "Replace All" |
*
* @param {Find_Replace_Replace_All_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_replace_all_label = /** @type {((inputs?: Find_Replace_Replace_All_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Replace_All_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout remplacer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle ersetzen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sostituisci tutto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Заменить все")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reemplazar todo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("全部替换")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべて置換")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी को बदलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Substituir tudo")
	return /** @type {LocalizedString} */ ("Replace All")
});